"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.universal = exports.tag = exports.string = exports.selector = exports.root = exports.pseudo = exports.nesting = exports.id = exports.comment = exports.combinator = exports.className = exports.attribute = void 0;
var attribute_1 = __importDefault(require("./attribute"));
var className_1 = __importDefault(require("./className"));
var combinator_1 = __importDefault(require("./combinator"));
var comment_1 = __importDefault(require("./comment"));
var id_1 = __importDefault(require("./id"));
var nesting_1 = __importDefault(require("./nesting"));
var pseudo_1 = __importDefault(require("./pseudo"));
var root_1 = __importDefault(require("./root"));
var selector_1 = __importDefault(require("./selector"));
var string_1 = __importDefault(require("./string"));
var tag_1 = __importDefault(require("./tag"));
var universal_1 = __importDefault(require("./universal"));
var attribute = function (opts) { return new attribute_1.default(opts); };
exports.attribute = attribute;
var className = function (opts) { return new className_1.default(opts); };
exports.className = className;
var combinator = function (opts) { return new combinator_1.default(opts); };
exports.combinator = combinator;
var comment = function (opts) { return new comment_1.default(opts); };
exports.comment = comment;
var id = function (opts) { return new id_1.default(opts); };
exports.id = id;
var nesting = function (opts) { return new nesting_1.default(opts); };
exports.nesting = nesting;
var pseudo = function (opts) { return new pseudo_1.default(opts); };
exports.pseudo = pseudo;
var root = function (opts) { return new root_1.default(opts); };
exports.root = root;
var selector = function (opts) { return new selector_1.default(opts); };
exports.selector = selector;
var string = function (opts) { return new string_1.default(opts); };
exports.string = string;
var tag = function (opts) { return new tag_1.default(opts); };
exports.tag = tag;
var universal = function (opts) { return new universal_1.default(opts); };
exports.universal = universal;
//# sourceMappingURL=constructors.js.map